import { render } from "./CustomizedContent.vue?vue&type=template&id=22ce1874&ts=true"
import script from "./CustomizedContent.vue?vue&type=script&lang=ts"
export * from "./CustomizedContent.vue?vue&type=script&lang=ts"

import "./CustomizedContent.vue?vue&type=style&index=0&id=22ce1874&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__